// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__JMi+c","header":"styles_header__dvGBA"};